/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskProfileResidualRisk } from './RiskProfileResidualRisk';
import {
  RiskProfileResidualRiskFromJSON,
  RiskProfileResidualRiskFromJSONTyped,
  RiskProfileResidualRiskToJSON,
} from './RiskProfileResidualRisk';

/**
 *
 * @export
 * @interface PaginatedRiskProfileResidualRiskList
 */
export interface PaginatedRiskProfileResidualRiskList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskProfileResidualRiskList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskProfileResidualRiskList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskProfileResidualRiskList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskProfileResidualRisk>}
   * @memberof PaginatedRiskProfileResidualRiskList
   */
  results: Array<RiskProfileResidualRisk>;
}

/**
 * Check if a given object implements the PaginatedRiskProfileResidualRiskList interface.
 */
export function instanceOfPaginatedRiskProfileResidualRiskList(
  value: object,
): value is PaginatedRiskProfileResidualRiskList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskProfileResidualRiskListFromJSON(json: any): PaginatedRiskProfileResidualRiskList {
  return PaginatedRiskProfileResidualRiskListFromJSONTyped(json, false);
}

export function PaginatedRiskProfileResidualRiskListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskProfileResidualRiskList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskProfileResidualRiskFromJSON),
  };
}

export function PaginatedRiskProfileResidualRiskListToJSON(value?: PaginatedRiskProfileResidualRiskList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskProfileResidualRiskToJSON),
  };
}
